import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import {
  BLACKLIST_SOURCE_TYPE,
  STATUS_ALL_VALUE,
} from '../../config/const.config';

const BlacklistSourceType = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  disabled,
  sx,
  error,
  allOption,
}) => (
  <FormControl fullWidth error={error !== ''} variant="filled">
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
    >
      {allOption && <MenuItem value={STATUS_ALL_VALUE}>All</MenuItem>}
      {BLACKLIST_SOURCE_TYPE.map((item) => (
        <MenuItem key={`${id}-v-${item.value}`} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

BlacklistSourceType.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  allOption: PropTypes.bool,
};
BlacklistSourceType.defaultProps = {
  disabled: false,
  sx: {},
  error: '',
  allOption: false,
};

export default BlacklistSourceType;
